import styled from "@emotion/styled";
import Autocomplete from "@mui/material/Autocomplete";
import {
  COLOR_BLACK_60,
  COLOR_GREY_2,
  COLOR_GREY_5,
  COLOR_WHITE,
} from "shared/theme/colors";
import { border } from "shared/theme/mixins";

export const StyledAutocomplete = styled(Autocomplete, {
  shouldForwardProp: (props) => props !== "borderColor",
})<{ borderColor?: string }>`
  width: 100%;

  .MuiFormControl-root {
    border: 1px solid ${(props) => props.borderColor || COLOR_GREY_5};
    border-radius: 0.75rem;

    .MuiOutlinedInput-root input {
      border: none;
    }

    .MuiOutlinedInput-root {
      border-radius: inherit;
      border: none;
      background-color: ${COLOR_WHITE};
    }

    #multiple-limit-tags {
      border: unset;
    }

    .MuiChip-root {
      background-color: ${COLOR_GREY_2};
      color: ${COLOR_BLACK_60};
      ${border(1, COLOR_GREY_5)};
      font-size: 0.875rem;
      font-weight: 500;
    }
  }
`;
